import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Input,
  ButtonGroup,
  Label,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button
} from 'reactstrap';

import {
  MdPhoto,
  MdPictureAsPdf,
  MdTextFormat,
  MdLiveHelp,
  MdFileUpload
} from 'react-icons/lib/md';

import { adicionarAnexo, salvarAnexosDiretamente } from "./actions";

const Anexo = ({ adicionarAnexo, anexos, processo: { situacao = {}, id: processoId }, habilitarEnvio = true, salvarAnexosDiretamente }) => {
  const definirIcone = tipo => {
    const Icone = (/jpeg|jpg|png/.test(tipo) && MdPhoto)
      || (/doc|txt|odt/.test(tipo) && MdTextFormat)
      || (tipo.endsWith("pdf") && MdPictureAsPdf)
      || MdLiveHelp;
    return <Icone size={30} />;
  }
  return (
    <Card tag="fieldset">
      <CardHeader tag="legend">
        Anexos
      </CardHeader>
      <CardBody>
        {
          anexos &&  anexos.length > 0 &&
          <Row>
            {
            anexos.map((anexo, i) =>
              <Col key={i} sm="12">
                {
                  definirIcone(anexo.type)
                }
                {"  "}
                <a href={anexo.id ? `/services/api/processos/${processoId}/anexos/${anexo.id}` : "#"}>{anexo.name || anexo.nome}</a>
              </Col>)
            }
          </Row>
        }
        {
          !situacao.fim && 
            <Row>
              <Col sm="12" className="text-right">
                <ButtonGroup size="sm" className="float-right">
                  <Input className="inputfile" id="file" type="file" name="file" onChange={({ target: { files: [anexo] } }) => adicionarAnexo(anexo)} />
                  <Label for="file">SELECIONAR</Label>
                  {
                    habilitarEnvio && < Button color="secondary" onClick={salvarAnexosDiretamente}><MdFileUpload />ANEXAR</Button>
                  }
                </ButtonGroup>
              </Col>
            </Row>
        }
      </CardBody>
    </Card >)
};


const mapStateToProps = state => ({
  anexos: state.anexo.anexos,
  processo: state.processo.processo
});

const mapDispatchToProps = dispatch => bindActionCreators({
  adicionarAnexo,
  salvarAnexosDiretamente
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Anexo);


// WEBPACK FOOTER //
// ./src/componentes/anexo/index.js